import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

type ActivitiesSessionIconProps = {
  size?: string
  strokeColor?: string
}

export const ActivitiesSessionIcon: FunctionComponent<ActivitiesSessionIconProps> = ({ size = '20', strokeColor }) => {
  const { colors } = useTheme()
  const { formatMessage } = useIntl()

  const accessibilityLabel = formatMessage({
    defaultMessage: 'Calendar',
    description: 'Accessibility label for calendar icon',
  })

  return (
    <Svg
      width={size}
      height={size}
      fill='none'
      testID={tID('ActivitiesSessionIcon')}
      accessible
      accessibilityRole='image'
      accessibilityLabel={accessibilityLabel}
    >
      <Path
        d='M15.8333 3.33337H4.16667C3.24619 3.33337 2.5 4.07957 2.5 5.00004V16.6667C2.5 17.5872 3.24619 18.3334 4.16667 18.3334H15.8333C16.7538 18.3334 17.5 17.5872 17.5 16.6667V5.00004C17.5 4.07957 16.7538 3.33337 15.8333 3.33337Z'
        stroke={strokeColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.334 1.66663V4.99996'
        stroke={strokeColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M6.66602 1.66663V4.99996'
        stroke={strokeColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M2.5 8.33337H17.5'
        stroke={strokeColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  )
}
